import { entityLangPath } from "@shapeable/utils";
import { useEntity } from "./use-entity";
export var useLangPath = function (lang, entityArg) {
  // take entity provided, or use default context entity
  var entity = useEntity(entityArg);
  // TODO - make this use a page dictionary to only provide the language version of the path if that page actually exists in the site (this requires a provider which can tell us which paths exist in the site)
  return entityLangPath(entity, lang);
};